// import Http from './http'; // não precisa de .js
import api from "../utils/api";

export const enviarEmail = (data) => api.post("/enviarEmail", data);
